module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-expanded-header"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-radio', {
    attrs: {
      "md-value": "elibrary",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("Ссылка на статью на E-Library.ru")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.$v.elibraryLink && _vm.$v.elibraryLink.$error
    },
    nativeOn: {
      "click": function($event) {
        _vm.ensureType('elibrary')
      }
    }
  }, [_c('label', [_vm._v("Ссылка")]), _vm._v(" "), _c('md-input', {
    ref: "elibraryInput",
    attrs: {
      "disabled": _vm.disabled || _vm.type !== 'elibrary'
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLoad($event)
      }
    },
    model: {
      value: (_vm.elibraryLink),
      callback: function($$v) {
        _vm.elibraryLink = $$v
      },
      expression: "elibraryLink"
    }
  }), _vm._v(" "), (_vm.$v.elibraryLink && _vm.$v.elibraryLink.$error) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n        Укажите ссылку на статью E-library вида https://elibrary.ru/item.asp?id=123456789\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('md-radio', {
    attrs: {
      "md-value": "resource",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("Ссылка на электронный ресурс")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.$v.resourceLink && _vm.$v.resourceLink.$error
    },
    nativeOn: {
      "click": function($event) {
        _vm.ensureType('resource')
      }
    }
  }, [_c('label', [_vm._v("Ссылка")]), _vm._v(" "), _c('md-input', {
    ref: "resourceInput",
    attrs: {
      "disabled": _vm.disabled || _vm.type !== 'resource'
    },
    model: {
      value: (_vm.resourceLink),
      callback: function($$v) {
        _vm.resourceLink = $$v
      },
      expression: "resourceLink"
    }
  }), _vm._v(" "), (_vm.$v.resourceLink && _vm.$v.resourceLink.$error) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n        Укажите URL электронного ресурса\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onToggleCustom
    }
  }, [_vm._v("Дополнительно...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onLoad
    }
  }, [_vm._v("Загрузить")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f150a0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogExpandedHeader.vue
// module id = 1016
// module chunks = 1